import { render, staticRenderFns } from "./SolicitudUnicaAdmin.vue?vue&type=template&id=1a0bdf54"
import script from "./SolicitudUnicaAdmin.vue?vue&type=script&lang=js"
export * from "./SolicitudUnicaAdmin.vue?vue&type=script&lang=js"
import style0 from "./SolicitudUnicaAdmin.vue?vue&type=style&index=0&id=1a0bdf54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports